import { defineMessages } from 'react-intl';

export default defineMessages({
  recommendedDesktop: {
    id: 'weRecommendUsingDesktopModal.recommendedDesktop',
    defaultMessage:
      'We detect mobile browsing, which is not recommended for accessing the Revers.io back office. We invite you to log in from a computer.',
  },
});
